module.exports = __webpack_public_path__ + "static/deux-soleils_purple-65f6650cec9490efb695961d8daf1b1a.png";